<app-dialog
  [title]="data.title"
  [actions]="data.actions"
  (action)="action($event)"
  (close)="close()"
>
<div class="amazon-case-template" *ngIf="!isCaseLink">
  <div class="amazon-case">
      <div class="amazon-case_body amazon-case_bodyWrapper">
        <div class="row" *ngIf="selectedTemplate">
          <div class="col-md-12">
            <div class="amazon-case_header">
              <div class="amazon-case_header--title d-flex align-items-center">
                <mat-form-field appearance="fill" class="mat-select-control mat-select-xs">
                  <mat-select [(ngModel)]="selectedTemplate" (ngModelChange)="onChange($event)" panelClass="templateSelect">
                    <mat-option [value]="templateName"
                      *ngFor="let templateName of templates"
                    >
                      {{ templateName.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="amazon-case_header--action d-flex align-items-center">
                <app-button [buttonSize]="'action'" [buttonStyle]="'text'" *ngIf="isEdit" (click)="navigate()"><i class="far fa-external-link-square-alt"></i></app-button>
                <!-- <span *ngIf="isEdit" (click)="navigate()"><i _ngcontent-rll-c231="" class="fal fa-external-link-square-alt"></i></span> -->
                <div class="d-flex" *ngIf="isEdit"[matMenuTriggerFor]="showTemplate">                  
                  <app-button [buttonSize]="'action'" [buttonStyle]="'text'" [buttonColor]="'primary'">
                    <svg width="10.51" height="12.01" class="mb-1 me-1"><use xlink:href="assets/images/sprite-icons.svg#clipboard_icon"></use></svg>
                    Add Value
                  </app-button>
                </div>
                  <app-button *ngIf="isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" [buttonColor]="'primary'" (click)="cancel()">Cancel</app-button>
                  <app-button *ngIf="isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" [buttonColor]="'primary'" (click)="copyText()">Apply</app-button>
                  <app-button *ngIf="!isEdit" [buttonSize]="'action'" [buttonStyle]="'text'" [buttonColor]="'primary'" (click)="edit()">Edit</app-button>
              </div>
          </div> 
          <div *ngIf="!isEdit" class="amazon-case_body--dragarea" [innerHtml]="selectedTemplate?.formattedText">
            </div>
            <textarea #textArea class="amazon-case_body--dragarea" *ngIf="isEdit" [formControl]="textAreaForm">{{selectedTemplate?.templateText}}</textarea>
          </div>
        </div>
        <div class="loader" *ngIf="!selectedTemplate">
          <img [src]="'assets/images/nineyard-loading.gif'" />
        </div> 
      </div>
  </div>
</div>
<div [formGroup]="form" *ngIf="isCaseLink">
   <div class="text-center py-5">
    <div class="form-status-img">
      <img class="mb-4" src="../../../../assets/images/check.png">
    </div>
    <h1 class="font-18">Case Submitted Successfully</h1>
   </div>
   <div class="input-container mb-3">
    <label class="input-container_label">Case Link</label>
    <div class="input-container_wrapper">
      <input type="text" class="input-container_input pr-5" formControlName="caseLink"/>
      <span class="input-container_icon input-container_icon--iconRight bg-transparent">
        <i class="fal fa-copy hand text-primary"></i>
      </span>
    </div>
  </div>
  <div class="input-container mb-3">
    <label class="input-container_label">Note</label>
    <textarea formControlName="note" class="input-container_input resize-none" rows="3"></textarea>
  </div>
</div>
<mat-menu #showTemplate="matMenu">
  <div class="importBoxesMenu" >
      <div class="importBoxesMenu-wrapper">
          <div *ngFor="let item of storeTemplateVar" class="importBoxesMenu-wrapper_tags" cdkDrag (click)="selectTemplate(item)">{{item.name}}</div>
      </div>
  </div>
</mat-menu>
</app-dialog>
